<template>
    <v-layout justify-center>
        <v-flex xs12 mt-4>

            <v-form
                    row
                    justify-center>

                <v-layout wrap>

                    <v-flex xs12 text-xs-left>
                        <v-select label="Tipo de atención" :items="typeOptions" v-model="type" />
                    </v-flex>

                    <v-flex xs12 text-xs-left :class="[{'sm6': type !== 'free'}]">
                        <v-select :disabled="type === 'free'" label="Estado del Pago" :items="statusOptions" v-model="status_detail" />
                    </v-flex>

                    <v-flex xs12 sm6 pl-2 v-if="type === 'medical_voucher'">
                        <v-text-field
                            :error-messages="voucherNumberError"
                            label="Folio del Bono"
                            placeholder=" "
                            clearable
                            v-model="voucherNumber" />
                    </v-flex>
                    <v-flex xs12 sm6 pl-2 v-if="type === 'private'">
                        <v-select type="number" label="Medio de Pago" :items="paymentOptions" v-model="paymentMethod" />
                    </v-flex>
                </v-layout>

                <v-text-field
                    :error-messages="amountError"
                    v-show="type !== 'free'"
                    label="Monto"
                    prefix="$"
                    :clearable="amount !== 0"
                    v-model="amount" />


            </v-form>
        </v-flex>

    </v-layout>
</template>

<script>

    import { mapState, mapMutations } from 'vuex'
    import {labels, getStatusByDetail} from '@/utils/Payment'

    export default{
        props: ['value'],
        components: {},
        mounted(){
             this.setDefault()
        },
        data(vm){
            return {
                status_detail: 'pending',
                type: 'private',
                amount: 0,
                paymentMethod: 'na',
                voucherNumber: '',

            }
        },
        watch:{
            valid(val){
                this.$emit('update:valid', val)
            },
            value(val){
                this.setDefault()
            },
            type(val){
                if(val !== 'private'){
                    this.paymentMethod = 'na'
                }else{
                    if(val === 'free'){
                        this.status_detail = 'done'
                    }
                    this.paymentMethod = 'cash'
                }
            },
            amount(val){
                this.amount = this.formatAmount(val)
            },
        },
        computed:{
            ...mapState(['loader', 'currentBranchOffice']),
            status(){
              return getStatusByDetail(this.status_detail)
            },
            amountError(){
                var vm = this
                if(vm.type !== 'free' && !vm.amount) {
                    return 'Requerido si la atención es por bono / particular'
                }

                return ''
            },
            voucherNumberError(){
                var vm = this
                if(vm.type === 'medical_voucher' && !vm.voucherNumber) {
                    return 'Requerido cuando la atención es por bono'
                }

                return ''
            },
            statusOptions(){

                var statuses = []
                for(var attr in labels){
                    statuses.push({
                        value: attr,
                        text: labels[attr]
                    })
                }

                return statuses
            },
            typeOptions(){
                return [
                    {
                        value: 'medical_voucher',
                        text:'Bono'
                    },
                    {
                        value: 'private',
                        text:'Particular'
                    },
                    {
                        value: 'free',
                        text:'Sin costo'
                    }
                ]
            },
            paymentOptions(){
                return [
                    {
                        value: 'na',
                        text:'Ninguno'
                    },
                    {
                        value: 'cash',
                        text:'Efectivo'
                    },
                    {
                        value: 'credit',
                        text:'Crédito'
                    },
                    {
                        value: 'debit',
                        text:'Débito'
                    },
                    {
                        value: 'Webpay',
                        text:'Webpay'
                    },
                ]
            },
            valid(){

                var vm = this

                if(vm.type !== 'free' && !vm.amount) return false
                if(vm.type === 'medical_voucher' && !vm.voucherNumber && vm.status_detail === 'normal') return false

                return true

            }
        },
        methods:{
            formatAmount(num) {
                if(!num) return 0
                return num.toString()
                        .replace(/^0/g, '')
                        .replace(/\./g, '')
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            },
            setDefault(){
                var vm = this
                if(!vm.value) return
                // console.log('vm.value',vm.value)
                vm.status_detail = vm.value.status_detail || 'pending'
                vm.type = vm.value.type || 'private'
                vm.amount = vm.value.amount || 0
                vm.paymentMethod = vm.value.payment_method || 'na'
                vm.voucherNumber = vm.value.voucher_number || ''

            },
            reset(){

                var vm = this
                vm.status_detail = 'pending'
                vm.type = 'private'
                vm.amount = 0
                vm.paymentMethod = 'na'
                vm.voucherNumber = ''

            },

            getPaymentData(){

                var vm = this
                let paymentData = {
                    status: vm.status,
                    status_detail: vm.status_detail,
                    type: vm.type,
                    amount: vm.amount && vm.amount.replace(/\./g, ''),
                    payment_method: vm.paymentMethod,
                    voucher_number: vm.voucherNumber
                }

                return paymentData

            }
        }

    }

</script>